import { host } from './Constants';

export const checkEnv = () => {
	const { origin } = window.location;
	const isDev = origin === host.development || origin === host.devExtHost;
	const isQA = origin === host.qa || origin === host.qaExtHost;
	const isUAT = origin === host.uat || origin === host.uatExtHost;
	let env = 'PROD';
	if (isDev || origin.indexOf('localhost') !== -1) {
		env = 'DEV';
	} else if (isUAT) {
		env = 'UAT';
	} else if (isQA) {
		env = 'QA';
	}
	return env;
};

const commonConfig = {
	isProd: process.env.NODE_ENV === 'production',
	isDev: process.env.NODE_ENV === 'development',
};

const getApiHost = () => {
	const location = window.location.origin;
	const hostEvn = host[process.env.NODE_ENV];
	let url;
	// NOTE: The following code is commented out as it was pointing to a UAT BE in DEV environment.
	// Uncomment if you want to point DEV to UAT BE.
	if (process.env.NODE_ENV === 'development' || location.indexOf('cus-d-ase') > 0) {
		// url = host.development.replace(/datadirect-ui/, 'gateway-service');
		console.log('Pointing DEV env to UAT BE');
		url = 'https://xde-gateway-service.xde-apm0004988-cus-u-ase.appserviceenvironment.net';
	} else if (location.indexOf('localhost') === -1) {
		url = location.replace(/datadirect-ui/, 'gateway-service');
	} else {
		url = hostEvn
			? hostEvn.replace(/datadirect-ui/, 'gateway-service')
			: null;
	}
	return url;
};

const prodConfig = {
	...commonConfig,
	serverUrl: getApiHost(),
};

const devConfig = {
	...commonConfig,
	serverUrl: getApiHost(),
};

const getHost = () => {
	let configData;
	if (commonConfig.isProd) {
		configData = prodConfig;
	} else {
		configData = devConfig;
	}
	return configData;
};

export const config = getHost();

// export config;
